import { useEffect, useState } from 'react'
import Template from './../../Template'
import * as SG from '../../../style/Styles'
import * as TXT from './../../../util/Texts'
import { useNavigate } from 'react-router-dom'
import * as LanguageService from './../../../services/Language.service'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { StyledTableCell, StyledTableRow } from './../../../components/table/Style'
import * as U from './../../../util/UrlHttp'

export default function Languages() {
  const navigate = useNavigate()
  const [langs, setLangs] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  const getAllLanguages = async () => {
    setLoading(true)
    const result = await LanguageService.GetLanguages()
    if (result.data && result.data.status) {
      setLangs(result.data.languages)
    }
    setLoading(false)
  }

  useEffect(() => {
    getAllLanguages()
  }, [])

  return (
    <Template>
      <SG.Title className='title'>{TXT.TRANSLATIONS}</SG.Title>

      <SG.BoxWhite className='tableBoxWhite' style={{ marginTop: 20 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <SG.IMG src='/img/loading.gif' alt='Carregando' style={{ width: 50 }} />
            <p>{TXT.LOADING_LANGUAGES}</p>
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="languages table">
              <TableHead>
                <TableRow>
                  <StyledTableCell className='userTh' style={{ width: '80px' }}>BANDEIRA</StyledTableCell>
                  <StyledTableCell className='userTh'>IDIOMA</StyledTableCell>
                  <StyledTableCell className='userActionTh userTh' style={{ width: '100px' }}></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {langs.length > 0 ? (
                  langs.map((row) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell className='txtTd'>
                        <img 
                          src={`${row.icon}`} 
                          alt={row.name_lang} 
                          onError={(e) => {
                            e.currentTarget.src = `${U.BASE_BACK}${U.ICON_BR}`;
                          }}
                          style={{ width: '40px', height: '26px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }}
                        />
                      </StyledTableCell>
                      <StyledTableCell className='txtTd' style={{ fontWeight: 'bold', fontSize: '15px' }}>{row.name_lang}</StyledTableCell>
                      <StyledTableCell align="center">
                        <SG.Span 
                          title="Editar Traduções" 
                          onClick={() => { navigate(`/languages-form/${row.id}`) }} 
                          className='alignMidd'
                          style={{ cursor: 'pointer', fontSize: '18px', color: '#1976d2' }}
                        >
                          <SG.I className="fa-solid fa-pen-to-square"></SG.I>
                        </SG.Span>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
                      Nenhum idioma encontrado
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </SG.BoxWhite>
    </Template>
  )
}
